export const SIGNIN = "SIGNIN";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const AUTH_TOKEN = "auth_token";
export const USER_INFO = "user_info";
